import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Alert,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { collection, getDocs } from "firebase/firestore";
import Navbar from "../Components/Navbar/navbar";
import { db } from "../Config/firebase";
import RelatorioAdesividadePrint from "../CadastroAdesividade/RelatorioAdesividadePrint";
import { consultaTenantAtual } from "../Utils/tenant";

function formatarDataBR(data) {
  if (!data) return "-";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

export default function RelatorioAdesividade() {
  const [ensaios, setEnsaios] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [selecionado, setSelecionado] = useState(null);
  const [autoPrint, setAutoPrint] = useState(false);
  const [erro, setErro] = useState("");

  useEffect(() => {
    let ativo = true;

    async function carregarEnsaios() {
      try {
        setErro("");
        const snap = await getDocs(
          consultaTenantAtual(collection(db, "tblAdesividadeLiganteBetuminoso"))
        );
        if (!ativo) return;

        const registros = snap.docs
          .map((item) => ({ id: item.id, ...item.data() }))
          .sort((a, b) => {
            const dataA = a.criadoEm?.toMillis?.() || a.criadoEm?.seconds || 0;
            const dataB = b.criadoEm?.toMillis?.() || b.criadoEm?.seconds || 0;
            return dataB - dataA;
          });
        setEnsaios(registros);
      } catch (falha) {
        console.error("Erro ao carregar relatórios de adesividade:", falha);
        if (ativo) {
          setErro("Não foi possível carregar os relatórios de adesividade. Verifique as permissões do usuário e tente novamente.");
        }
      }
    }

    carregarEnsaios();
    return () => {
      ativo = false;
    };
  }, []);

  const lista = useMemo(() => {
    const termo = filtro.trim().toLowerCase();
    if (!termo) return ensaios;
    return ensaios.filter((item) =>
      [item.codigo, item.cliente, item.obra, item.material]
        .some((valor) => contemTextoPesquisa(String(valor || "").toLowerCase(), termo))
    );
  }, [ensaios, filtro]);

  if (selecionado) {
    return (
      <RelatorioAdesividadePrint
        ensaio={selecionado}
        autoPrint={autoPrint}
        onVoltar={() => {
          setSelecionado(null);
          setAutoPrint(false);
        }}
      />
    );
  }

  return (
    <>
      <Navbar />
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Typography variant="h6" fontWeight={700}>Relatórios de Adesividade</Typography>
        <Typography variant="body2">Agregado graúdo - adesividade ao ligante betuminoso</Typography>
      </Box>
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
        <TextField
          fullWidth
          size="small"
          label="Pesquisar por código, cliente, obra ou material"
          value={filtro}
          onChange={(event) => setFiltro(event.target.value)}
          sx={{ mb: 2 }}
        />
        <Paper sx={{ overflow: "auto", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Código</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Obra</TableCell>
                <TableCell>Material</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lista.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{formatarDataBR(item.dataEnsaio)}</TableCell>
                  <TableCell>{item.codigo || "-"}</TableCell>
                  <TableCell>{item.cliente || "-"}</TableCell>
                  <TableCell>{item.obra || "-"}</TableCell>
                  <TableCell>{item.material || "-"}</TableCell>
                  <TableCell align="center">
                    <Tooltip title="Visualizar">
                      <IconButton onClick={() => { setAutoPrint(false); setSelecionado(item); }}>
                        <VisibilityIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </>
  );
}
